import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-profile-photo',
    imports: [],
    templateUrl: './profile-photo.component.html',
    styleUrl: './profile-photo.component.scss'
})
export class ProfilePhotoComponent {
@Input() img:any='';
@Input() isEditable:boolean=false;
@Output() onClickImage:EventEmitter<any>=new EventEmitter<any>(); 
@Output() onEdit:EventEmitter<any>=new EventEmitter<any>(); 




}
